import { useRef } from "react";
import TagInput from "@/components/ui/TagInput";
import { normalizeSmartSearchText } from "@shared/search/smartSearch";

interface IndustryTagInputProps {
  value: string[];
  onChange: (tags: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
}

export function IndustryTagInput({ value, onChange, disabled, placeholder }: IndustryTagInputProps) {
  const previousValue = useRef<string[]>(value);

  const handleChange = async (newValue: string[]) => {
    const normalizedValue = newValue.slice(-1);
    const added = normalizedValue.filter((item) => !previousValue.current.some((previous) => normalizeSmartSearchText(previous) === normalizeSmartSearchText(item)));
    previousValue.current = normalizedValue;

    for (const label of added) {
      try {
        await fetch("/api/company-classification/terms", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ field: "industry", label, source: "user_created", confirmed: true }),
        });
      } catch (error) {
        console.error("[IndustryTagInput] Failed to create:", error);
      }
    }

    onChange(normalizedValue);
  };

  return (
    <TagInput
      value={value}
      onChange={handleChange}
      disabled={disabled}
      placeholder={placeholder}
      suggestionsEndpoint="/api/company-classification/terms?field=industry"
    />
  );
}
